import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTableModule } from '@angular/material/table';
import { TranslocoPipe } from '@jsverse/transloco';
import { ModalComponent } from '@web/birdz-angular';

@Component({
  selector: 'app-modal-help-sewerin-data-reporting',
  imports: [ModalComponent, MatTableModule, TranslocoPipe, MatExpansionModule],
  templateUrl: './modal-help-sewerin-data-reporting.component.html',
  styleUrl: './modal-help-sewerin-data-reporting.component.scss',
})
export class ModalHelpSewerinDataReportingComponent {
  data = inject(MAT_DIALOG_DATA);
}
